import React, { useState, useEffect } from 'react';

import { makeStyles } from "@material-ui/core/styles";
import Table from "components/Table/Table.js";
import { Modal } from "react-bootstrap";
import 'bootstrap/dist/css/bootstrap.min.css';

import api from "assets/services/api";

import img0 from "assets/img/products/0.png";
import img1 from "assets/img/products/1.png";
import img2 from "assets/img/products/2.png";
import img3 from "assets/img/products/3.png";
import img4 from "assets/img/products/4.png";
import img5 from "assets/img/products/5.png";
import img6 from "assets/img/products/6.png";
import img7 from "assets/img/products/7.png";
import img8 from "assets/img/products/8.png";
import img9 from "assets/img/products/9.png";

const styles = {
    imageTabulation: {
        width: 90,
        height: 90,
        borderRadius: 90,
        marginRight: 20 / 2
    }
}

const useStyles = makeStyles(styles);

function ModalViewTabulationOperator(props) {

    const [tabulation, setTabulation] = useState([]);
    const images = [img0, img1, img2, img3, img4, img5, img6, img7, img8, img9]
    const classes = useStyles();



    useEffect(() => {
        handleShowTabulation()
    }, [props.props.id])

    async function handleShowTabulation() {
        const response = await api.get('tabulation/client/' + props.props.id);
        setTabulation(response.data);
    }

    function getTabulation() {
        let teste = [];
        for (let i = 0; i < tabulation.length; i++) {
            teste[i] = [];
            switch (tabulation[i].code) {
                case "12": {
                    teste[i].push(
                        <img
                            className={classes.imageTabulation}
                            src={images[0]}
                            title={tabulation[i].name}
                            alt={tabulation[i].name}
                        />
                    )
                    break;
                }
                case "15": {
                    teste[i].push(
                        <img
                            className={classes.imageTabulation}
                            src={images[1]}
                            alt={tabulation[i].name}
                        />
                    )
                    break;
                }
                case "16": {
                    teste[i].push(
                        <img
                            className={classes.imageTabulation}
                            src={images[2]}
                            alt={tabulation[i].name}
                        />
                    )
                    break;
                }
                case "26": {
                    teste[i].push(
                        <img
                            className={classes.imageTabulation}
                            src={images[3]}
                            alt={tabulation[i].name}
                        />
                    )
                    break;
                }
                case "27": {
                    teste[i].push(
                        <img
                            className={classes.imageTabulation}
                            src={images[4]}
                            alt={tabulation[i].name}
                        />
                    )
                    break;
                }
                case "1": {
                    teste[i].push(
                        <img
                            className={classes.imageTabulation}
                            src={images[5]}
                            alt={tabulation[i].name}
                        />
                    )
                    break;
                }
                case "18": {
                    teste[i].push(
                        <img
                            className={classes.imageTabulation}
                            src={images[6]}
                            alt={tabulation[i].name}
                        />
                    )
                    break;
                }
                case "11": {
                    teste[i].push(
                        <img
                            className={classes.imageTabulation}
                            src={images[7]}
                            alt={tabulation[i].name}
                        />
                    )
                    break;
                }
                case "40": {
                    teste[i].push(
                        <img
                            className={classes.imageTabulation}
                            src={images[8]}
                            alt={tabulation[i].name}
                        />
                    )
                    break;
                }
                default:
                    break
            }

            teste[i].push(tabulation[i].name)
            teste[i].push("R$" + tabulation[i].standart_price);
            teste[i].push("R$" + tabulation[i].price_of_product);
        }
        return teste;
    }

    return (
        <Modal
            {...props}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
        >
            <Modal.Header closeButton>
                <Modal.Title id="contained-modal-title-vcenter">
                    Tabela de preços de {props.props.social_reason}
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Table
                    tableHeaderColor="primary"
                    tableHead={["", "Produto", "Preço padrão", "Preço"]}
                    tableData={getTabulation()}
                />
            </Modal.Body>
        </Modal>
    );
}

export default ModalViewTabulationOperator;